<template>
  <div
    class="Login"
    @click="$emit('close')"
  >
    <div
      class="login-box"
      @click.stop
    >
      <img src="@/assets/images/logo.svg">
      <form
        @keyup.enter="login"
      >
        <BaseInput
          v-model="email"
          type="text"
          name="form-username"
          :placeholder="$t('AUTHORFORM.EMAILPLACEHOLDER')"
          required
        />
        <BaseInput
          v-model="password"
          type="password"
          name="form-password"
          :placeholder="$t('AUTHORFORM.PASSWORDPLACEHOLDER')"
          required
        />
      </form>
      <router-link
        to="/"
      >
        <p
          class="recover"
          @click="showModal"
        >
          {{ $t('BUTTON.PASSWORDRECOVER') }}
        </p>
      </router-link>

      <p
        v-if="error"
        class="error"
      >
        {{ $t('ERROR.PASSWORD') }}
      </p>

      <BaseButton
        @click="login"
      >
        {{ $t('BUTTON.LOGIN') }}
      </BaseButton>
    </div>
    <transition name="fade">
      <RecoverPassword
        v-if="isOpen"
        @close="isOpen = false"
      />
    </transition>
  </div>
</template>

<script>
import ValidationMixin from '@/mixins/ValidationMixin.js';
import RecoverPassword from '@/components/RecoverPassword';

export default {

  components: { RecoverPassword },

  mixins: [ValidationMixin],

  data: () => ({
    email: '',
    password: '',
    error: false,
    isOpen: false,
  }),

  methods: {

    showModal() {
      this.isOpen = true;
    },

    async login() {
      const currentForm = document.forms[0];
      const formData = new FormData(currentForm);
      const email = formData.get('form-username');
      const password = formData.get('form-password');

      this.checkAllFields(currentForm);

      if (this.areErrors()) {
        this.$toast.error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
      } else {
        const data = { email, password };
        this.send(data);
        this.$emit('close');
      }
    },

    async send(data) {
      this.$store.dispatch('authModule/login', data)
        .then((response) => {
          window.Vue.$router.push({ path: `/author/${response.user.id}` });
        });
    },
  },

};
</script>

<style lang="scss" scoped>
.Login {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .login-box {
    padding: 2rem 4rem;
    background-color: rgb(33, 33, 49);
    border-radius: 1rem;
    width: 450px;
    text-align: center;
    img{
      width: 250px;
      margin-bottom: 1rem;
    }
    .BaseInput {
      ::v-deep {
        input {
          border-radius: 10px;
          border: solid 2px var(--color-primary);
          // border-bottom: solid 1px white;
          color: rgb(37, 35, 35);
          text-align: center;
          border-radius: 10px;
          width: 100%;
          padding-top: 6px;
          margin-bottom: 1rem;
        }
      }
    }
    .recover{
      color:white;
      text-align: left;
      margin-top: -15px;

    }
    .BaseButton {
      margin-top: 15px;
      text-align: center;

    }
  }
}
</style>
